import type p5 from 'p5'
import type { Point } from '../../types'

export abstract class BaseHandle {
  p: p5
  _position: Point

  constructor(p: p5) {
    this.p = p
  }

  //TODO Consider having the handles handle their own event and update their own internal state
  //rather than relying on the marker to set / update it's state

  abstract isMousedOver()

  abstract setupStroke()

  abstract render()

  getLocalCoordinates() {
    return this.p.localMousePosition()
  }

  set position(newPosition: Point) {
    this._position = newPosition
  }

  get position() {
    return this._position
  }
}
